var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 2.5C10.4599 2.5 10.833 2.8731 10.833 3.33333C10.833 3.76069 10.5113 4.11292 10.0969 4.16106L9.99967 4.16667H5.83301C5.40565 4.16667 5.05342 4.48837 5.00528 4.90282L4.99967 5V15C4.99967 15.4274 5.32138 15.7796 5.73582 15.8277L5.83301 15.8333H9.58301C10.0433 15.8333 10.4163 16.2064 10.4163 16.6667C10.4163 17.094 10.0947 17.4463 9.68019 17.4944L9.58301 17.5H5.83301C4.50161 17.5 3.41329 16.4593 3.33725 15.1469L3.33301 15V5C3.33301 3.6686 4.37378 2.58028 5.68611 2.50424L5.83301 2.5H9.99967ZM14.7555 7.05372L17.1126 9.41075C17.438 9.73617 17.438 10.2638 17.1126 10.5892L14.7555 12.9462C14.4301 13.2717 13.9025 13.2717 13.577 12.9462C13.2516 12.6208 13.2516 12.0932 13.577 11.7677L14.5115 10.8333H9.99967C9.53942 10.8333 9.16634 10.4602 9.16634 10C9.16634 9.53975 9.53942 9.16667 9.99967 9.16667H14.5115L13.577 8.23223C13.2516 7.9068 13.2516 7.37916 13.577 7.05372C13.9025 6.72828 14.4301 6.72828 14.7555 7.05372Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.25816b63cb0bdc9bf8fdf36743bd7d4a.svg";
export { ForwardRef as ReactComponent };